export const ar = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'إضافة نص',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'إضافة إلى العربة',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'محاذاة القاع',
  ALIGN_CENTER_KEY: 'محاذاة المركز',
  ALIGN_KEY: 'محاذاة',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'محاذاة الأوسط',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'محاذاة الأعلى',
  ALL_TAB_TITLE_KEY: 'الكل',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'الخلفية',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'لا توجد إلهام تحت هذه الفئة',
  BRING_TO_FRONT_KEY: 'إحضار إلى المقدمة',
  CANCEL_TEXT_KEY: 'إلغاء الأمر',
  CENTIMETERS_KEY: 'سنتيمترات',
  CM_KEY: 'سم',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'اختر ملف',
  CITY: 'City',
  CLEAR_ALL_KEY: 'مسح الكل',
  CLEAR_COLOR_KEY: 'مسح اللون',
  CLOSE_WINDOW_KEY: 'إغلاق النافذة',
  CLEAR_ALL_OBJECTS: 'مسح كل الكائنات',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'يؤدي ذلك إلى إزالة كل الكائنات من خلفيتك.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'اللون',
  CONTINUE_KEY: 'متابعة...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '‎© 2013-{0} HPDC, L.P.‎‏',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'سم',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'تصميم',
  DELETE_KEY: 'حذف',
  DOCUMENT_COLORS: 'ألوان الوثيقة',
  DONE: 'Done!',
  DONE_KEY: 'تم',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'تنزيل',
  DOWNLOAD_APP_TITLE_KEY: 'يمكنك تنزيل التطبيق من هنا:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'استيراد المربع المنسدل',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'بحث Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'صور Dreamstime',
  DUPLICATE_KEY: 'مطابق',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'تحرير التصميم',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'معذرةً، حدث خطأ. يرجى إعادة المحاولة لاحقًا.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'للأسف، حدث خطأ أثناء فتح ملف PDF الذي تم تحميله.',
  EMAIL_KEY: 'بريد إلكتروني',
  EMAIL_ADDRESS_KEY: 'عنوان البريد الإلكتروني:',
  EMAIL_CHECKBOX_MESSAGE:
    'أعلم أن هذا الشخص يدرك أنه سيستلم رسائل بريد إلكتروني من HP نيابة عني أو موفر الخدمة هذا.',
  EXTRA_INFO_KEY: 'معلومات إضافية',
  EMAIL_NOTIFICATION:
    'سيتم إرسال بريد إلكتروني إليك قريبًا. يرجى السماح حتى 15 دقيقة للمعالجة.',
  EMAIL_DIALOG_MESSAGE:
    'اكتب عنوان البريد الإلكتروني للشخص الذي تريد مشاركة تصميمك معه.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'مجلد حالي',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'تأكد من صحة جميع العناصر المحددة قبل الشروع في الخروج',
  FINAL_CHECK_TITLE_KEY: 'فحص نهائي',
  FINISH_KEY: 'إنهاء',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'عكس',
  FOR_KEY: 'إلى عن على',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'الكلمات الرئيسية:',
  FOLDER_NAME: 'اسم المجلد',
  FOLDER_NAME_KEY: 'اسم المجلد:',
  FOLDER_ALREADY_EXIST_KEY: 'اسم المجلد الحالي موجود بالفعل',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'تجميع الكل',
  GROUP_SCALE: 'تغيير حجم المجموعة',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'امنح مشروعك اسمًا',
  HEIGHT_KEY: 'الارتفاع',
  HELP_KEY: 'تعليمات',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'الصور',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'جارٍ الاستيراد',
  INCHES_COLUMN_HEADER_KEY: 'بوصة',
  INCHES_KEY: 'بوصات',
  INCHES_UNIT_STRING_KEY: 'بوصة',
  INVALID_EMAIL_ADDRESS_KEY: 'عنوان بريد إلكتروني غير صحيح',
  INVALID_INFO_KEY: 'الرجاء إدخال تفاصيل.',
  INVALID_NAME_KEY: 'اسم غير صحيح',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'معذرةً، الملف الذي حددته كبير جدًا. الحد الأقصى لحجم الملف يكون 500 م.ب.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'للأسف، ليس تنسيق ملف صالح. يمكننا التعامل مع pdf وjpg وpng وsvg وtif فقط.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'اللغة',
  LASTNAME: 'Last name',
  LEARN_MORE: 'معرفة المزيد',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY: 'يعد استخدامك لهذا الموقع موافقة على هذه',
  LEGAL_FOOTER_MESSAGE2_KEY: 'يتوافق موقع الويب هذا مع',
  LEGAL_FOOTER_MESSAGE3_KEY: 'و',
  LENGTH_STRING_IN_INCHES_KEY: 'بوصة',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'لتصور المحتوى الذي ستضيفه، يُرجى تنزيل التطبيق LinkReader.',
  LOADING_KEY: 'جارٍ التحميل...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'قفل',
  LOGIN_KEY: 'تسجيل الدخول',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'تسجيل الدخول إلى Dreamstime',
  LOGOUT_KEY: 'تسجيل الخروج',
  MATERIAL_TITLE_KEY: 'MATERIAL',
  MATERIAL_STRING_KEY: 'المادة',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'يتعذر تقليل حجم هذه الخلفية أيضًا لأنك وصلت إلى الحد الأدنى للارتفاع أو العرض المطلوب لتغطية حائطك.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'الطراز',
  MORE_INFO_TEXT_KEY: 'مزيد من المعلومات',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'معذرةً، ملفات PDF متعددة الصفحات غير مدعومة.',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'الاسم:',
  NEXT_BUTTON_TITLE_KEY: 'التالي',
  NEW_FOLDER_KEY: 'مجلد جديد',
  NO_SHADOW_KEY: 'بلا ظل',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'موافق',
  ORDER_SAMPLE_KEY: 'طلب عينة',
  ORDER_SAMPLE: 'طلب عينة',
  ORDER_SAMPLE_INFOLABEL_1: 'حدد جزء الصورة الذي تريد طلبه كعينة',
  ORDER_SAMPLE_INFOLABEL_2:
    'ستستلم رسالة إلكترونية تتضمن عرضًا عن قرب لمشروعك بالحجم الفعلي',
  ORDER_SAMPLE_INFOLABEL_3: 'سيساعدك ذلك في تقييم جودته ودقته',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'طلب عينة الآن',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'استلم بريد إلكتروني يتضمن عرض قريب لمشروعك بالحجم الفعلي لتقييم جودته/دقته.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'كلمة المرور',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design‏',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'أملك حقوق النشر لهذه الصورة وأوافق على',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'بكسل',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'سم',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'بمعنى أن بعض الأشياء الهامة التي تحتاجها للتواصل مع متجر الطباعة',
  PLACEHOLDER_INCHES_STRING_KEY: 'بوصة',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'المكان',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'حفظ مشروعك',
  PRE_CHECK_SAVE_DIALOG_MESSAGE: 'مشروعك يتضمن تغييرات يجب حفظها قبل المتابعة.',
  PRICE_COLUMN_HEADER_KEY: 'السعر',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'جارٍ المعالجة...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'معاينة',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'اسم المشروع',
  PROJECT_NAME: 'اسم المشروع:',
  PROJECT_ALREADY_EXIST_KEY: 'اسم المشروع الحالي موجود بالفعل',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'اسم المشروع الحالي موجود بالفعل',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'اسم المجلد الحالي موجود بالفعل',
  PIXELATION_WARNING_KEY: 'تحذير بخصوص ظهور وحدات بكسل',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'نظرًا لدقة صورتك التي تم تحميلها ، قد تكون بشرتك مشوهة أو مشوهة. لضمان عدم وجود ضبابية ، يرجى تحميل صورة بجودة جيدة وتجنب تمدد الصورة. إذا كنت راضيًا عن المعاينة وترغب في المتابعة ، فيرجى متابعة الإرسال.',

  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'مطلوب',
  RECOLOR_KEY: 'إعادة التلوين',
  RECOLORING_KEY: 'تتم الآن إعادة التلوين...',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'إعادة التلوين',
  REQUEST_SAMPLE_KEY: 'طلب عينة',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'طلب عرض الأسعار',
  RIGHT_LOGO_TEXT_KEY: 'بواسطة',
  ROTATE_KEY: 'تدوير',
  ROTATE_LEFT_KEY: 'تدوير 90° لليسار',
  ROTATE_RIGHT_KEY: 'تدوير 90° لليمين',
  ROTATION_KEY: 'تدوير',
  ROWS_COLUMN_LABEL_STRING_KEY: 'الصفوف والأعمدة',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'حفظ',
  SAVING_KEY: 'جارٍ حفظ...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'حفظ مشروعك',
  SAVE_PROJECT_NAME_KEY: 'حفظ مشروعك أولاً',
  SAVEDIALOG_MESSAGE:
    'يرجى تسجيل الدخول لحفظ مشروعك. إذا لم يكن لديك حساب، سنساعدك في إنشاء حساب. لن يتم فقدان تقدمك.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'تغيير الحجم',
  SCALE_ALL_KEY: 'تغيير حجم الكل',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'بحث',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'بحث',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'إرسال إرشادات التثبيت إليّ',
  SEND_TO_BACK_KEY: 'إرسال للخلف',
  SEND_KEY: 'إرسال',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: ' تعيين الحجم ',
  SETTINGS_KEY: 'الإعدادات',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'مشاركة',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'قدم مربعة',
  SQM_UNIT_STRING_KEY: 'متر مربع',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'خضع',
  SHARE_LINK_LABEL: 'حدد نوع الارتباط الذي تريد مشاركته',
  SHARE_EDIT_LINK: 'تحرير ارتباط',
  SHARE_VIEW_LINK: 'عرض ارتباط',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* يمكن تغيير مسافة العرض الهدف من خلال الإعدادات.',
  TERMS1_KEY: 'الشروط',
  TERMS2_KEY: 'بيان الخصوصية من HP‏',
  TERMS3_KEY: 'إشعار HP‏ بخصوص حقوق البيانات الشخصية',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'بنود الاستخدام.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'الإطار المتجانب',
  TOTAL_KEY: 'إجمالي',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'شكرًا لك',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'إلغاء القفل',
  UNGROUP_KEY: 'إلغاء التجميع',
  UPDATE_TEXT_KEY: 'تحديث',
  UPLOAD_KEY: 'تحميل الصورة',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'اسم المستخدم',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'إزالة الإطار المتجانب',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'مدة الصلاحية',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'ضريبة القيمة المضافة',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'عرض في Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'عرض تفاصيل التصميم',
  VIEW_DESIGNER_PROFILE_KEY: 'عرض ملف تعريف المصمم',
  VIEW_PRICE_KEY: 'عرض السعر',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'ملصق الحائط',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'تحذير',
  WEBSITE: 'Website',
  WIDTH_KEY: 'العرض',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'اسمك',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'مشروعك:',
  PROJECT_NAME_ERROR_TEXT: 'يرجى إدخال اسم لمشروعك.',
  PROJECT_FOLDER_ERROR_TEXT: 'يرجى إدخال اسم لمجلد مشروعك.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'الحد الأدنى لمسافة العرض ',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'لم يتم العثور على محتويات dreamstime',
  NO_ELEMENT_ERROR_MESSAGE: 'لم يتم العثور على أي عنصر.',
  NO_MORE_IMAGES_FOUND_KEY: 'لم يتم العثور على المزيد من الصور',
  NO_PATTERN_ERROR_MESSAGE: 'لم يتم العثور على نقوش.',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'الرسالة:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'لقد تدرجت إلى نقطة حيث تبدو صورتك المطبوعة مقطعة عند العرض في {0} {1} * (الدة المطبوعة الحالية تكون {2} نقطة في البوصة).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'يجب أن تكون مسافة العرض الموصى بها {0} {1}. إذا لم يكن هذا مناسبًا، فيرجى تقليل نطاق الصورة أو حجم صورة الخائط.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'ينبغي أن يكون الحد الأدنى الموصى به لحجم الصورة {0} * {1} بكسل.',
  UPLOAD_STATUS: '{0}% من {1}ميجابايت',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'أدنى أبعاد تكون {0}(عرض) في {1} (ارتفاع).',
  MINIMUM_HEIGHT_KEY: 'أدنى ارتفاع يكون {0}.',
  MINIMUM_WIDTH_KEY: 'أدنى عرض يكون {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'أقصى عرض يكون {0}',
  MAXIMUM_HEIGHT_KEY: 'أقصى ارتفاع يكون {0} {1}.',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'يرجى إدخال أبعاد رقمية أكبر من الصفر.',
  PROCESSING_FAILED: 'فشل المعالجة، يرجى المحاولة قريبًا',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: 'عذرًا، ملفات PDF المشفرة غير مدعومة.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'استيراد الملف {0} من {1}',
  DROPBOX_IMPORT_ERROR_HEADER: 'حدثت مشكلة أثناء استيراد بعض الملفات',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'مصدر هذا المحتوى محمي بكلمة مرور',
  AUTHENTICATE_FAILED_MESSAGE: 'فشلت المصادقة!',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'تحذير حجم الصفحة!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'يأتي نموذج الإلهام هذا بحجم افتراضي يبلغ {0} X {1} {2}. سيتم تغيير حجم صفحتك تلقائيًا لتناسب هذا القالب.',
  MODIFY_SIZE_WARNING:
    'إذا كنت ترغب في تغيير حجم هذا التصميم ، يمكنك القيام بذلك في علامة التبويب "الإعدادات". قد تتطلب عناصر التصميم التحرير للتكيف مع الأبعاد المطلوبة.',
  RANDOMIZE_KEY: 'بطريقة عشوائية',
  MATERIAL_CHOICE_APPLIED: 'اختيار المواد المطبقة.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'اختيار الكمبيوتر المحمول',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: 'Go back',
  FIRST_NAME_KEY: 'الاسم الأول',
  LAST_NAME_KEY: 'اسم العائلة',
  PHONE_NUMBER_KEY: 'رقم الهاتف',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'رقم هاتف غير صحيح',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'أقبل الشروط والأحكام',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'أقبل أنه ستتم مشاركة معلوماتي الشخصية مع HP للاتصال بي بشأن حملات HP المستقبلية.*',
  SERVICE_PROVIDER_CONDITION:
    'أقبل أنه قد تتم مشاركة البيانات التي أقدمها مع موفري الخدمة لأغراض الطباعة والتوصيل.*',
  ORDER_DESIGN: 'طلب تصميم',
  SUBMIT_YOUR_DESIGN: 'إرسال تصميمك',
  SUBMISSION_DESIGN_ORDER: 'إرسال طلب التصميم',
  ENTER_REQUIRED_FIELDS_KEY: 'الرجاء إدخال الحقول المطلوبة',
  ADDRESS_KEY: 'العنوان',
  INVALID_ADDRESS_KEY: 'عنوان غير صحيح',
  CITY_KEY: 'المدينة',
  INVALID_CITY_KEY: 'مدينة غير صحيحة',
  COUNTRY_KEY: 'البلد',
  STATE_KEY: 'الولاية',
  ZIP_KEY: 'الرمز البريدي',
  INVALID_ZIP_KEY: 'رمز بريدي غير صحيح',
  YOUR_DETAILS_KEY: 'تفاصيلك',
  APPLY_DESIGN_COMPETITION: 'التقدم لمسابقة التصميم',
  ORDER_NUMBER: 'رقم الطلب',
  NOTICE_KEY: 'تنويه:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'للحصول على شكل ملائم تمامًا لجهاز الكمبيوتر لديك ، يجب عليك تحديد النموذج الدقيق المقابل لعملية الشراء ، كما هو موضح في الفاتورة.',
  RESTART_PROJECT_ALERT_TITLE: 'إعادة بدء مشروع؟',
  DISCARD_ALERT_MESSAGE: 'سيتم تجاهل مشروعك الحالي',
  RESTART: 'إعادة التشغيل',
  BLOCKCHAIN_STRING: 'بلوك تشين',
  CERTIFICATE_STRING: 'شهادة',
  AUTHENTICITY_STRING: 'أصالة',
  PLEASE_WAIT: 'الرجاء الانتظار',
  PROTECTING_YOUR_DATA: 'جارٍ حماية بياناتك...',
  SEARCH_YOUR_LAPTOP_KEY: 'بحث الكمبيوتر المحمول الخاص بك', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'وجه الفتاة! لم نتمكن من العثور على أي أجهزة كمبيوتر محمولة للبحث.', // Google translated
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'الرقم التسلسلي',
  LOCKED_PROJECT: 'مشروع مقفل',
  LOCKED_MESSAGE:
    'تم تقديم طلب هذا المشروع ولا يمكن تغييره. يمكنك فقط عرض هذا المشروع.',
  EXPIRED_PROJECT: 'المشروع انتهت صلاحيته',
  EXPIRED_MESSAGE: 'هذا المشروع انتهت صلاحيته..',
  DELETED_PROJECT: 'المشروع محذوف',
  DELETED_MESSAGE: 'هذا المشروع قد حُذف.',
  CHOOSE_GROUP_TYPE: 'اختيار نوع {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'يرجى إدخال أرقام أكبر من الصفر.',
  SIZE_KEY: 'الحجم',
  DISTANCE_FROM_KEY: 'المسافة من',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'يسار',
  RIGHT_KEY: 'يمين',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'أقصى حجم للحائط يكون {1} مربع.{0}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'ارتفاع الألواح النسيجية يتجاوز ارتفاع الحائط.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'عرض الألواح النسيجية يتجاوز عرض الحائط.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    '{الحد الأقصى للصفوف للارتفاع الحالي هو {0',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY: 'الحد الأقصى للصفوف للارتفاع الحالي هو {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'عرض الحائط أقل من عرض الألواح النسجية.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: 'يجب أن يكون الحائط بأقل عرض  {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'يجب أن يكون الحائط بأقل ارتفاع  {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'ارتفاع الحائط أقل من ارتفاع الألواح النسجية.',
  MAXIMUM_WALL_HEIGHT_KEY: 'أقصى ارتفاع للحائط يكون  {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'الصفوف',
  COLUMNS_KEY: 'الأعمدة',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'تحرير',
  TOP_KEY: 'الأعلى',
  BOTTOM_KEY: 'أسفل'
};
